import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import loader from "vue3-ui-preloader";
// Import the CSS or use your own!
import "vue3-ui-preloader/dist/loader.css"
/*createApp(App).use(store).use(router).mount('#app')
App.component('EasyDataTable', Vue3EasyDataTable);*/

const app = createApp(App);
app.component('loader', loader)
app.use(store);
app.use(router);
app.component('EasyDataTable', Vue3EasyDataTable);
app.config.globalProperties.$rutaServer = 'https://api.seigrupo.com.mx/api/'
//app.config.globalProperties.$rutaServer = 'http://127.0.0.1:8000/api/';
//app.config.globalProperties.$rutaImagenes = 'http://127.0.0.1:8000/';
app.config.globalProperties.$rutaImagenes = 'https://api.seigrupo.com.mx/';



app.mount('#app');
